import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]

import AddToBasketButtonContent from '@/shared/form/AddToBasketButtonContent.vue';
import { computed, Ref, ref } from 'vue';
import basketStore from '@/shared/checkout/basket/basket.store';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import useProductAddOns from '@/shared/product/add-ons/useProductAddOns';
import useTEMPB2CFeatureBasket from '@/b2c/basket/useTEMPB2CFeatureBasket';
import basketTrackingService from '@/shared/tracking/basket-tracking.service';
import { useAddToBasket } from '@/b2c/product/purchase/useAddToBasket';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutletProductDetailPurchase',
  setup(__props) {

const labels = useBlockLabels();

const { outletProductData } = useOutletProductDetailData();
const { addAddOnsToBasketSynchronous, hasSelectedAddOns: hasAddedMultiple, forceAddingState, addedAddOnsLabel } = useProductAddOns();
const { addOutletItem } = useTEMPB2CFeatureBasket();
const { addToBasket } = useAddToBasket();

const pending: Ref<boolean> = ref(false);

const messageId = `outletAddToBasket${outletProductData.value.recId}`;

const submit = async(): Promise<void> => {
    basketTrackingService.outlet(outletProductData.value);
    if (!pending.value) {
        pending.value = true;
    }

    forceAddingState();
    await addOutletItem(outletProductData.value.recId, messageId);
    await handleAddOns();

    await getOutletItemStockStatus();

    pending.value = false;
    if (hasAddedMultiple.value) {
        basketStore.get();
    }
};

const handleAddOns = async() => {
    if (hasAddedMultiple.value) {
        await addAddOnsToBasketSynchronous(addToBasket);
    }
};

const isOutletItemInStock = ref(true);

const getOutletItemStockStatus = async(): Promise<void> => {
    isOutletItemInStock.value = await basketStore.outletItemInStock(outletProductData.value.recId);
};

const basketButtonDefaultText = computed(() => isOutletItemInStock.value ? labels.addToBasket : labels.notInStock);
const basketButtonAddedText = computed(() => addedAddOnsLabel.value ? addedAddOnsLabel.value : labels.addedToBasket);

getOutletItemStockStatus();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(outletProductData).outletLocation || _unref(outletProductData).outletLocation.isStorage)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          disabled: !isOutletItemInStock.value,
          class: "c-button c-button--primary min-w-220 transition-colors mt-x4 md:mt-x5",
          onClick: submit
        }, [
          _createVNode(AddToBasketButtonContent, {
            pending: pending.value,
            "added-button-text": _unref(basketButtonAddedText),
            "default-button-text": _unref(basketButtonDefaultText)
          }, null, 8, ["pending", "added-button-text", "default-button-text"])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(WebApiMessage, {
      id: messageId,
      "clear-timing": 5000
    })
  ], 64))
}
}

})